
import Vue from "vue";
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddShipRepairPracticeRequest, ApiException,
    factory, IAddShipRepairPracticeRequest, PracticesClient,
    ShipRepairPracticeActions, ShipRepairPracticeDetailsModel
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import ShipRepairPracticeUpsertForm from "@/features/documents/practices/components/ShipRepairPracticeUpsertForm.vue";
import {Location} from "vue-router";

interface Props {
    seafarerId: string;
    actions: ShipRepairPracticeActions;
    existingPractice: ShipRepairPracticeDetailsModel;
}

@Component({
    components: {
        ShipRepairPracticeUpsertForm,
        FormLayout
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditShipRepairPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        const practiceId = to.params.id;
        Promise.all([
            new PracticesClient().availableShipRepairActions(),
            new PracticesClient().getShipRepair(practiceId),
        ]).then(values => {
            props.actions = values[0];
            props.existingPractice = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class EditShipRepairPractice extends Vue implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: ShipRepairPracticeActions;

    @Prop({required: true})
    existingPractice!: ShipRepairPracticeDetailsModel;

    @Prop({default: null})
    returnRoute!: Location | null;

    model: AddShipRepairPracticeRequest = factory.create(AddShipRepairPracticeRequest);

    isCreated = false;

    async created() {
        this.model = new AddShipRepairPracticeRequest({
            ...this.existingPractice,
            existingFiles: this.existingPractice.files,
            addedFiles: [],
            removedFiles: []
        } as IAddShipRepairPracticeRequest)
        this.isCreated = true;
    }

    async submit(model: AddShipRepairPracticeRequest) {
        await new PracticesClient()
            .edit(model, this.seafarerId, this.existingPractice.id);

        const route = (this.returnRoute ? this.returnRoute : { name: "ship-repair-practice-details" }) as Location;
        route.params = {id: this.existingPractice.id, seafarerId: this.seafarerId};
        this.$router.replace(route);
    }
}
